export default "__VITE_ASSET__Dxlyddo7__"